module.exports = __webpack_public_path__ + "img/download.19d9800c.svg";